<template>
  <div v-if="order.basket" class="orderdetails">
    <div>
      <h2>Bestellte Artikel</h2>
      <table class="products -mt-2" style="width:100%; max-width:640px;">
        <thead>
          <tr>
            <th class="p-2 text-left">Artikel</th>
            <th class="p-2 text-right whitespace-no-wrap">Preis</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in order.basket" class="product">
            <td class="p-2">
              <strong>{{ item.productdata.item_title }} ({{ item.humanSize }})</strong>
              <ul class="pl-4 text-sm" style="list-style-type: none;">
                <li v-for="addon in item.basketaddons">
                  <template v-if="!(addon.count == 0 && addon.included == 0)">
                    <span v-if="addon.count > 0">✅ mit</span>
                    <span v-if="addon.count <= 0">⭕️ ohne</span>
                    <span v-if="addon.count == 2">doppelt</span>
                    <span v-if="addon.count == 3">dreifach</span>
                    {{ addon.title }}
                    <template v-if="addon.count > addon.included && addon.price > 0">{{ addon.price | pricetag }}</template>
                  </template>
                </li>
              </ul>
              <div v-if="item.item_note" class="text-sm"><strong>Hinweise:</strong> {{ item.item_note }}</div>
              <div v-if="item.item_multiuser" class="text-sm text-green-heinz">Bestellt von {{ item.item_multiuser }}</div>
            </td>
            <td class="p-2 align-top text-right whitespace-no-wrap">{{ item.price | pricetag }}</td>
          </tr>
          <tr v-if="mbwDeviation" class="product">
            <td class="p-2"><strong>💸 Differenz Mindestbestellwert</strong></td>
            <td class="p-2 align-top text-right">{{ mbwDeviation | pricetag }}</td>
          </tr>
          <tr v-if="order.order.tip > 0" class="product">
            <td class="p-2"><strong>😍 Trinkgeld</strong></td>
            <td class="p-2 align-top text-right">{{ order.order.tip | pricetag }}</td>
          </tr>
          <tr v-if="order.order.shipping > 0" class="product">
            <td class="p-2"><strong>🚚 Lieferkosten</strong></td>
            <td class="p-2 align-top text-right whitespace-no-wrap">{{ order.order.shipping | pricetag }}</td>
          </tr>
          <tr v-if="order.order.coupon > 0" class="product">
            <td class="p-2"><strong>🎁 Eingelöster Gutscheincode</strong></td>
            <td class="p-2 align-top text-right whitespace-no-wrap">-{{ order.order.coupon | pricetag }}</td>
          </tr>
          <tr class="product">
            <td class="p-2"><strong>Gesamt</strong></td>
            <td class="p-2 align-top text-right font-bold whitespace-no-wrap">{{ total | pricetag }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div v-if="multiUserCount > 0" class="mb-6">
        <h2>Mitbestellerschulden</h2>
        <table class="products -mt-2" style="width:100%; max-width:640px;">
          <tr v-for="(value, key) in multiTotals" class="product">
            <td class="p-2 font-bold">{{ key }}</td>
            <td class="p-2 text-right whitespace-no-wrap">{{ value | pricetag }}</td>
          </tr>
        </table>
      </div>

      <div v-if="order.order.comment" class="mb-6">
        <h2>Hinweise</h2>
        {{ order.order.comment }}
      </div>

      <div class="mb-6">
        <h2>Lieferadresse</h2>
        <template v-if="order.order.homedelivery === 'N'">Die Bestellung muss an o.g. Adresse abgeholt werden.</template>
        <template v-if="order.order.homedelivery === 'Y'">
          <div v-if="order.order.company" class="font-bold">{{ order.order.company }}</div>
          <div :class="{ 'font-bold': !order.order.company }">{{ order.order.firstname }} {{ order.order.lastname }}</div>
          {{ order.order.street }} {{ order.order.number }}<br />
          {{ order.order.zip }} {{ order.order.city }}<br />
          {{ order.order.addressaddon }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrderDetails',

  props: {
    order: {
      type: Object,
      default: {}
    }
  },

  data () {
    return {

    }
  },

  computed: {
    productsTotal () {
      let productsTotal = 0

      Object.values(this.order.basket).forEach(item => {
        productsTotal += item.price
      })

      return productsTotal
    },

    mbwDeviation () {
      if(this.order.order.homedelivery === 'N') return 0
      return this.order.order.mbw > this.productsTotal ? (this.order.order.mbw - this.productsTotal) : 0
    },

    total () {
      return (this.order.order.sum + this.order.order.shipping + this.order.order.tip)
    },

    multiUserCount () {
      return Object.values(this.multiTotals).length
    },

    multiTotals () {
      let multiTotals = {}

      Object.values(this.order.basket).forEach(item => {
        if(item.item_multiuser) {
          if(typeof multiTotals[item.item_multiuser] === 'undefined') multiTotals[item.item_multiuser] = 0
          multiTotals[item.item_multiuser] += item.price
        }
      })

      return multiTotals
    }
  },

  created () {

  },

  destroyed () {

  },

  methods: {}
}
</script>

<style lang="scss" scoped>
  .orderdetails {
    & > div:nth-child(even) {
      @apply mt-6;
    }

    @screen lg {
      @apply flex;

      & > div {
        @apply flex-1;

        &:nth-child(even) {
          @apply pl-2;
          @apply mt-0;
        }

        &:nth-child(odd) {
          @apply pr-2;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderDetails.vue